// Website-specific version: the API base URL is fixed at build time via
// VITE_API_BASE_URL. Unlike the desktop app, there's no user-facing
// "server settings" dialog here -- letting a random website visitor
// repoint the app at an arbitrary backend URL doesn't make sense for a
// public site the way it does for a self-hostable desktop app (that
// feature exists there for power users running their own backend). If you
// ever want that here too, port ServerSettingsDialog.jsx over deliberately
// rather than assuming it's needed.
export const DEFAULT_URL = import.meta.env.VITE_API_BASE_URL || "https://api.mytokenguard.com";

export function getBaseUrl() {
  return DEFAULT_URL;
}
